<template>
  <nav :class="$style.toolbar">
    <Grid hasGap>
      <GridItem :gridSpan="5">
        <InputSearch
          :class="$style.search"
          data-test-id="Toolbar_inputSearch"
          :focus="shouldFocusSearch"
          :placeholder="searchPlaceholder"
          @input="triggerSearch"
        />
      </GridItem>
      <GridItem
        :class="$style.text"
        :gridSpan="4"
      >
        <Select
          v-if="showFilter"
          v-model="filter"
          data-test-id="viewall_filters"
          :options="selectOptions"
        />
      </GridItem>
      <GridItem
        :class="$style.dropdownClass"
        :gridSpan="3"
      >
        <DropdownActions
          v-if="dropdownActions && dropdownActions.length"
          buttonText="Actions"
          :class="$style.dropdown"
          data-test-id="viewall__actionDropDown"
          :isDisabled="disabled"
          :items="dropdownActions"
          position="right"
        />
        <Button
          v-if="showButtons"
          :class="$style.buttonClass"
          data-test-id="viewall__actionButton"
          text="Accept & Save"
          textCase="capitalize"
          type="primary"
          @click="emitSuggestionAction"
        />
      </GridItem>
    </Grid>
  </nav>
</template>

<script>
import {
  Button,
  DropdownActions,
  Grid,
  GridItem,
  InputSearch,
  Select,
} from '@jumpcloud/ui-components';
import SegmentEventMixin from 'client/HomePageV2/mixins/SegmentEventMixin';

export default {
  name: 'HomeSearchBar',
  components: {
    Button,
    DropdownActions,
    Grid,
    GridItem,
    InputSearch,
    Select,
  },

  mixins: [SegmentEventMixin],

  props: {
    count: {
      type: Number,
      default: 0,
    },
    disabled: Boolean,
    dropdownActions: {
      type: Array,
      default: () => [],
    },
    filterValue: {
      type: String,
      default: 'all',
    },

    searchPlaceholder: {
      type: String,
      default: 'Search',
    },

    selectOptions: {
      type: Array,
      default: () => [],
    },

    shouldFocusSearch: Boolean,

    showButtons: {
      type: Boolean,
      default: false,
    },

    showFilter: {
      type: Boolean,
      default: false,
    },

    toolBarDisplayName: {
      type: String,
      default: '',
    },
  },

  computed: {
    filter: {
      get() {
        return this.filterValue;
      },
      set(value) {
        this.$emit('triggerFilter', value);
      },
    },
  },

  methods: {
    emitCancelAction() {
      this.$emit('triggerClear');
    },

    emitSuggestionAction() {
      this.$emit('triggerSuggestionUpate');
    },

    triggerSearch(value) {
      this.triggerInputEnteredHandler(value, this.toolBarDisplayName);
      this.$emit('triggerSearch', value);
    },
  },
};
</script>

<style scoped module>
.buttonClass {
  margin: var(-jc-spacer-x-small);
}

.toolbar {
  align-items: center;
  padding: var(--jc-spacer) 0 0.25rem;
}

.text {
  display: inline-block;
  line-height: 1.2;
  vertical-align: middle;
}

.dropdownClass {
  align-items: flex-end;
  max-width: 100%;
}

.search {
  min-height: 0;
  padding: 0 var(--jc-spacer-small);
}

.dropdown:not(.legacyOverride):not(.legacyOverride) {
  z-index: 7;
}
</style>
